export default __webpack_public_path__ + "static/media/inactive-voucher.3c27276e.svg";